<!-- eslint-disable vue/no-parsing-error -->
<template>
    <div class="Home container">
        <Btn></Btn>
        <Card>
            <div :class="[type=='forgotPassword'? 'cardWrapper mt-2 red' : 'cardWrapper mt-2']" class="text-center">
                <div @click="$router.go(-1)" style="text-align: left;" class="kembali backBtn text-blue mb-3"><i class="fas fa-chevron-left"></i>
                    Kembali
                </div>
                <div class="text-center text-bold">Masukkan kode OTP yang dikirim ke nomor {{numb}}</div>

                <small class="text-center">kode OTP anda berlaku selama {{ timer.minutes > 9 ? timer.minutes : '0' +timer.minutes }} : {{ timer.seconds > 9 ? timer.seconds : '0'+ timer.seconds }}</small>
                <form @submit.prevent="verifikasi">
                    <div class="inputWrapper mt-2">
                        <input
                          type="text" v-for="(key, i) in activationKeyFields" :key="i"
                          onkeydown="javascript: return event.keyCode === 8 ||event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                          :data-length="key.length" :data-index="i" :ref="`input-${i}`" v-model="key.value"
                          maxlength="1" @keyup="handleActivationInput($event)"
                        />
                    </div>
                    <button :class="[type==='forgotPassword'? 'btn-fill red rounded mt-2' : 'btn-fill blue rounded mt-2']">Verifikasi</button>
                </form>
                <button @click="$router.go(-1)" class="btnBackBottom btn-outline blue rounded">Kembali</button>
            </div>
        </Card>
        <Loader v-if="isLoad" />
    </div>
</template>

<script>
import Card from '../components/cardCenter.vue'
import Btn from '../components/backBtn.vue'
import Loader from '../components/loader.vue'
import encoded from '../mixins/encodeForm'
import axios from 'axios'

export default {
  components: {
    Card,
    Btn,
    Loader
  },
  mixins: [encoded],
  beforeCreate () {
    document.title = 'Partai Perindo - Area Anggota OTP'
  },
  data () {
    return {
      numb: '',
      type: '',
      pass: '',
      activityID: '',
      isLoad: false,
      form: null,
      activationKeyFields: [{
        length: 1,
        value: ''
      },
      {
        length: 1,
        value: ''
      },
      {
        length: 1,
        value: ''
      },
      {
        length: 1,
        value: ''
      }

      ],
      timer: {
        minutes: 0,
        seconds: 0
      },
      interval: null
    }
  },
  mounted () {
    this.numb = this.$route.params.number
    this.type = this.$route.params.type
    this.pass = this.$cookie.getCookie('password')
    this.activityID = this.$cookie.getCookie('activityID')
    const valid = localStorage.getItem('valid')
    this.interval = setInterval(() => {
      this.calculateTimeLeft(valid)
    }, 1000)
    // if (!this.pass) {
    //     this.logger('password tidak ada')
    //     this.$router.push('/')
    // }
  },
  unmounted () {
    clearInterval(this.interval)
  },
  methods: {
    async verifikasi () {
      this.isLoad = true
      this.form = {
        number: this.numb,
        otp: this.activationKey,
        password: this.pass,
        user_activity_id: this.activityID
      }

      if (this.type !== 'forgotPassword') {
        try {
          const verOtp = await axios.post('auth/verifyotp', this.data)
          if (verOtp.data && verOtp.data.token) {
            this.alertNormal('Sukses Register Akun :)')
            // this.logger(verOtp, 'verOtpverOtp')
            // this.$router.push('/login')
            this.$cookie.removeCookie('valid')
            this.$cookie.removeCookie('password')
            this.$cookie.removeCookie('activityID')
            this.$cookie.setCookie('token', verOtp.data.token)
            // this.$store.commit('setToken', verOtp.data.token)
            this.$router.push('/dashboard')
          }
          this.isLoad = false
        } catch (err) {
          this.isLoad = false
          if (err.response) {
            // this.logger(err.response.data)
            this.toast({ type: err.response?.data?.status, message: err.response?.data?.message })
            this.activationKeyFields = [{
              length: 1,
              value: ''
            },
            {
              length: 1,
              value: ''
            },
            {
              length: 1,
              value: ''
            },
            {
              length: 1,
              value: ''
            }
            ]
          }
        }
      } else {
        try {
          const verOtp = await axios.patch('auth/verifyforgotpassword', this.data)
          if (verOtp.status < 300) {
            this.alertNormal('Sukses Forgot Password :)')
            this.$router.push('/login')
            this.$cookie.removeCookie('password')
          }
          this.isLoad = false
        } catch (err) {
          this.isLoad = false
          if (err.response) {
            this.toast({ type: err.response?.data?.status, message: err.response?.data?.message })
            this.activationKeyFields = [{
              length: 1,
              value: ''
            },
            {
              length: 1,
              value: ''
            },
            {
              length: 1,
              value: ''
            },
            {
              length: 1,
              value: ''
            }
            ]
          }
        }
      }
    },
    //    clickEvent(e){
    //        this.logger(e)
    // if(e.target.nextElementSibling != null){
    // document.getElementById(e.target.nextSibling.id).focus();
    // }
    // }
    handleActivationInput (e) {
      // Grab input's value
      const value = e.target.value
      // Grab data-index value
      const index = parseInt(e.target.dataset.index)
      this.logger(index, '1st index')
      // Grab data-length value
      const maxlength = parseInt(e.target.dataset.length)

      // this.logger(index, 'index input',this.activationKeyFields[index].value.length, maxlength)
      // this.logger(value.length, maxlength, 'value length , maxlengt')
      if (this.activationKeyFields[index].value.length > maxlength) {
        e.preventDefault()
        this.activationKeyFields[index].value = value.slice(0, 1)
        // this.logger(index, 'bbbb')
        try {
          this.$refs[`input-${parseInt(index + 1)}`].focus()
        } catch (e) {}
        return
      }

      // Shift focus to next input field if max length reached

      if (value.length >= maxlength) {
        this.logger(this.activationKeyFields[2].value, 'index')
        if (typeof this.activationKeyFields[index + 1] === 'undefined') {
          e.preventDefault()
          if (this.activationKeyFields[2].value !== '') {
            if (e.keyCode === 13) {
              this.logger('submit data')
              this.verifikasi()
            }
          }
          return
        }
        // this.logger(this.$refs[`input-${parseInt(index + 1)}`], 'ref')

        this.$refs[`input-${parseInt(index + 1)}`].classList.add('mystyle')
        this.$refs[`input-${parseInt(index + 1)}`].focus()
        e.preventDefault()
      } else {
        // this.logger(index, 'else index')
        if (typeof this.activationKeyFields[index - 1] === 'undefined') {
          e.preventDefault()
          return
        }
        this.$refs[`input-${parseInt(index - 1)}`].focus()
        e.preventDefault()
      }
      // this.logger(e)
    },
    calculateTimeLeft (endTime) {
      const difference = +new Date(endTime) - +new Date()

      if (difference > 0) {
        this.timer.minutes = Math.floor((difference / 1000 / 60) % 60)
        this.timer.seconds = Math.floor((difference / 1000) % 60)
      }
    }
  },
  computed: {
    activationKey () {
      let value = ''
      for (const field of this.activationKeyFields) {
        value += field.value
      }
      return value
    }
  }
}
</script>

<style lang="scss" scoped>
    @import '../assets/scss/Layout/home.scss';

    .Home {
        .cardWrapper {
            .inputWrapper {
                display: flex;
                padding: 0 40px;
                justify-content: space-around;

                input {
                    width: 55px;
                    height: 55px;
                    border-radius: 10px;
                    border: none;
                    background-color: #dee3f0;
                    text-align: center;

                }
            }

            &.red {
                input {
                    background-color: #fddddd;
                }
            }
        }
    }
</style>
